<template>
    <div class="market-select-container">
        <Title :title="title" />
        <div class="market-select-content">
            <table>
                <tbody>
                    <tr v-for="row in rows" :key="row">
                        <td v-for="col in itemsPerRow" :key="col">
                            <div class="market-select-item"
                                :class="{ 'active': selectData && selectData.id == getItem(row, col - 1).id }"
                                @click="handleSelectData(row, col - 1)">
                                <p>{{ getTranslatedText(getItem(row, col - 1).name || '') }}</p>
                                <p class="odds">{{ formatPrice(getItem(row, col - 1).odds) }}</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="market-select-action">
            <ButtonCommon text="add" class="button__primary" :isDisable="!selectData" @action="addSelect" />
        </div>
    </div>
</template>
<script>
import utilsMixin from '@/mixins/function-utils';
import Title from "@/components/common/title/index.vue";
import ButtonCommon from "@/components/common/button";
import EventBus from '@/utils/EventBus';
import languageMixins from '@/mixins/language-mixins';

export default {
    mixins: [utilsMixin, languageMixins],
    components: { Title, ButtonCommon },
    props: {
        outcomes: {
            type: Array,
        },
        title: {
            type: String,
        },
    },

    watch: {
        '$store.state.isScreenMobile': {
            handler(isMobile) {
                this.itemsPerRow = (this.outcomes.length == 2 || isMobile) ? 2 : 3;
                this.calculateRows()
            },
            deep: true,
        },
    },
    data() {
        return {
            selectData: null,
            rows: [],
            itemsPerRow: 3,
        }
    },
    created() {
        this.itemsPerRow = (this.outcomes.length == 2 || this.$store.state.isScreenMobile) ? 2 : 3;
        this.calculateRows()
    },
    methods: {
        calculateRows() {
            const totalItems = this.outcomes.length;
            const totalCells = Math.ceil(totalItems / this.itemsPerRow) * this.itemsPerRow;
            const numberOfRows = totalCells / this.itemsPerRow;

            this.rows = Array.from({ length: numberOfRows }, (_, i) => i + 1);
        },
        getItem(row, col) {
            const index = (row - 1) * this.itemsPerRow + col;
            return this.outcomes[index] || '';
        },

        handleSelectData(row, col) {
            const item = this.getItem(row, col);
            if (item) this.selectData = item;
        },

        addSelect() {
            this.$emit('addSelect', this.selectData)
            this.selectData = null;

            setTimeout(() => {
                EventBus.emit('calculate-bottom-page')
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/public/scss/components/coupons/market-select.scss";
</style>